// @ts-nocheck




import { createAction, createSlice } from '@reduxjs/toolkit';

import { wialonTripApi } from '../lib/api';



export const FETCH_TRIP = 'vehicles/wialonTrip/fetch';
export const CLEAN_TRIP = 'vehicles/wialonTrip/clean';



const initialState: any = null;

const fetchWialonTripAction = createAction<any>(FETCH_TRIP);
const cleanWialonTripAction = createAction(CLEAN_TRIP);

const wialonTripSlice = createSlice({
  name: 'wialonTrip',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(fetchWialonTripAction, (state, { payload }) => ({ ...payload })).
    addCase(cleanWialonTripAction, () => null);
  }
});

export const wialonTripActions = {
  fetch: fetchWialonTripAction,
  clean: cleanWialonTripAction
};

export const updateWialon =
(id, params) =>
async (dispatch) => {
  try {
    await wialonTripApi.updateWialonData(id);
    // const trip = await wialonTripApi.getWialonData(params);
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
  return await dispatch(fetchTrip(id));
};

export const updateTrip =
(trip) =>
async (dispatch, getState) => {
  const updated = await wialonTripApi.update(trip);

  // Обновляем стейт, если только в нем что-то есть,
  // т.к. обновление ПЛ (путевого листа) может происходит
  // не только в форме и карточке ПЛ
  if (getState().trip !== null) {
    dispatch(wialonTripActions.fetch({ ...updated }));
  }
  return updated;
};

export const fetchTrip =
(id) =>
async (dispatch) => {
  const trip = await (wialonTripApi.get as any)(id);

  dispatch(wialonTripActions.fetch(trip));
  return trip;
};

export const cleanTrip =
() =>
(dispatch) =>
dispatch(wialonTripActions.clean());

export default wialonTripSlice.reducer;
